function CircularCrossUnpaidIcon() {
  return (
    <svg width="121" height="120" viewBox="0 0 121 120" fill="none">
      <rect x="3" y="2.5" width="115" height="115" rx="57.5" fill="#F92F6C" />
      <rect
        x="3"
        y="2.5"
        width="115"
        height="115"
        rx="57.5"
        fill="url(#paint0_radial_2361_1529)"
        fillOpacity="0.5"
      />
      <rect
        x="3"
        y="2.5"
        width="115"
        height="115"
        rx="57.5"
        stroke="url(#paint1_linear_2361_1529)"
        strokeWidth="5"
      />
      <path
        d="M81.9675 74.4993C82.4442 74.9506 82.8253 75.4932 83.0885 76.0951C83.3516 76.697 83.4914 77.3459 83.4996 78.0036C83.5078 78.6612 83.3842 79.3142 83.1361 79.924C82.888 80.5338 82.5205 81.0879 82.0553 81.5537C81.59 82.0194 81.0365 82.3874 80.4274 82.6357C79.8183 82.8841 79.166 83.0078 78.5091 82.9996C77.8522 82.9914 77.204 82.8515 76.6027 82.588C76.0015 82.3246 75.4595 81.943 75.0087 81.4658L60.6276 67.0688C60.6086 67.0498 60.5861 67.0346 60.5612 67.0243C60.5363 67.014 60.5097 67.0088 60.4827 67.0088C60.4558 67.0088 60.4291 67.0142 60.4042 67.0246C60.3793 67.0349 60.3567 67.0501 60.3376 67.0692L45.9146 81.5082C45.459 81.972 44.9163 82.3411 44.318 82.5943C43.7198 82.8475 43.0777 82.9797 42.4288 82.9834C41.7799 82.9871 41.1372 82.8621 40.5375 82.6157C39.9379 82.3692 39.3932 82.0063 38.935 81.5477C38.4768 81.0891 38.1141 80.5439 37.8678 79.9437C37.6216 79.3434 37.4966 78.6999 37.5001 78.0504C37.5036 77.4008 37.6355 76.7579 37.8883 76.1589C38.1411 75.5599 38.5096 75.0166 38.9728 74.5603L53.3958 60.1213C53.4149 60.1023 53.43 60.0796 53.4404 60.0547C53.4508 60.0298 53.4561 60.0031 53.4562 59.9761C53.4562 59.9491 53.4509 59.9224 53.4406 59.8975C53.4304 59.8726 53.4153 59.85 53.3962 59.831L39.0151 45.434C38.5532 44.9792 38.1861 44.437 37.9349 43.8388C37.6837 43.2406 37.5535 42.5982 37.5517 41.9486C37.55 41.299 37.6767 40.6552 37.9246 40.0541C38.1725 39.4531 38.5366 38.9068 38.9961 38.4468C39.4555 37.9867 40.0011 37.622 40.6014 37.3737C41.2017 37.1254 41.8448 36.9984 42.4937 37C43.1425 37.0016 43.7843 37.1319 44.3819 37.3832C44.9795 37.6345 45.5211 38.0019 45.9756 38.4642L60.3567 52.8612C60.3757 52.8803 60.3982 52.8954 60.4231 52.9057C60.448 52.916 60.4746 52.9213 60.5016 52.9212C60.5285 52.9212 60.5552 52.9158 60.5801 52.9055C60.605 52.8951 60.6276 52.8799 60.6467 52.8608L75.0697 38.4218C75.9952 37.5099 77.2421 37.0001 78.5388 37.0033C79.8355 37.0066 81.0769 37.5226 81.9926 38.4391C82.9083 39.3556 83.4241 40.5982 83.4276 41.8964C83.4311 43.1945 82.9222 44.4429 82.0115 45.3697L67.5885 59.8087C67.5694 59.8278 67.5543 59.8504 67.5439 59.8753C67.5335 59.9003 67.5282 59.927 67.5281 59.9539C67.5281 59.9809 67.5334 60.0076 67.5437 60.0325C67.554 60.0574 67.569 60.08 67.5881 60.099L81.9692 74.496L81.9675 74.4993Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2361_1529"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(60.2235 120) rotate(90) scale(80.2941 60.547)"
        >
          <stop stopColor="white" stopOpacity="0.65" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2361_1529"
          x1="24.8318"
          y1="-1.98729e-05"
          x2="114.209"
          y2="14.594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.36" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default CircularCrossUnpaidIcon;
